import { WithClassName } from 'src/utils/UtilityTypes';

interface Props extends WithClassName {
	fillColor?: string;
	size: number;
}
const InfoFilled = ({ fillColor, size, className }: Props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 16 16"
			fill="none"
			className={className}
		>
			<path
				d="M7.99902 1.33301C11.6809 1.33301 14.666 4.3181 14.666 8C14.666 11.6819 11.6809 14.667 7.99902 14.667C4.31713 14.667 1.33203 11.6819 1.33203 8C1.33203 4.3181 4.31713 1.33301 7.99902 1.33301ZM7.99902 7.33301C7.7229 7.33301 7.33209 7.60181 7.33203 7.87793V11.5449C7.33228 11.8209 7.72297 12 7.99902 12C8.27517 12 8.66602 11.7761 8.66602 11.5V7.87793C8.66596 7.60181 8.27515 7.33301 7.99902 7.33301ZM7.99902 4.66699C7.63094 4.66699 7.33221 4.96497 7.33203 5.33301C7.33203 5.7012 7.63083 6 7.99902 6C8.36721 6 8.66602 5.7012 8.66602 5.33301C8.66584 4.96497 8.3671 4.66699 7.99902 4.66699Z"
				fill={fillColor ?? 'currentColor'}
			/>
		</svg>
	);
};

export default InfoFilled;
